import moment from 'moment';
import { computed, defineComponent, ref } from 'vue';
export default defineComponent({
    name: 'DatePicker',
    props: {
        value: String,
        label: String,
        rules: Array
    },
    setup(props, { emit }) {
        const menu = ref(false);
        return {
            menu,
            date: computed(() => moment(props.value).format('YYYY-MM-DD')),
            input(value) {
                menu.value = false;
                emit('input', value);
            }
        };
    }
});
